<div id="configurator">
  <div class="row no-gutters {{activeRouteStyle}} {{isAnonymousMode ? 'anonymous' : ''}}" id="configuratorContainer" #configuratorContainer>
    <!-- Composite manager -->

    <ng-container *ngIf="showComposite">

      <div class="{{compositeStyles}} left-panel" #leftPanel>
        <!-- TODO: Do we need 'padding-right' ? -->
        <composite-menu [isAnonymous]="isAnonymousMode" [activeRoute]="activeRouteStyle" [showStickyOption]="isEditor"></composite-menu>
      </div>

      <div class="col-auto splitter"
           HorizontalResize
           [resizeTarget]="leftPanel"
           [resizeContainer]="configuratorContainer"
           [minWidth]="minCompositeWidth"
           [rightReservedWidth]="isEditor ? 100 : 500"
           [shouldRender]="shouldRenderComposite"
           (resized)="onCompositeResized($event)"
           >

        <div class="splitter-handle"></div>

      </div>

    </ng-container>

    <div class="col scrollable-view right-panel">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="row configurator-footer mx-0" *ngIf="confPageSession.dataLoaded && (isEditor || isAnonymousMode)">
    <div class="col">
      <control-panel [activeRoute]="activeRouteStyle"
                     [isAnonymousMode]="isAnonymousMode"
                     (save)="onSave()"
                     (modify)="onModify()"
                     (startOver)="onStartOver()"
                     (saveExit)="onSaveAndExitEditor()"
                     (mandatory)="onMandatoryClick()"
                     (close)="onCloseConf()"></control-panel>
    </div>
    <div class="col-auto align-middle copyright">
      Powered by ®COMBINUM
    </div>
  </div>
</div>

<!-- NOTE! Draggable popups must be defined here  -->
<disallowed-popup></disallowed-popup>
<read-only-popup></read-only-popup>
<cleared-popup></cleared-popup>
<automatic-unlock-popup></automatic-unlock-popup>
<mandatory-popup (onClosed)="onMandatoryClosed()"></mandatory-popup>
<warning-variables-popup></warning-variables-popup>
<help-popup></help-popup>
<rule-confirmation-popup></rule-confirmation-popup>
<anonymous-dialog-popup [saving]="isEditor" (onClosed)="onAnonymousClosed($event)"></anonymous-dialog-popup>
<anonymous-contact-popup (onClosed)="onAnonymousContactClosed($event)"></anonymous-contact-popup>
<bom-image-popup></bom-image-popup>
<code-popup></code-popup>
<warning-price-popup></warning-price-popup>